module.exports = __webpack_public_path__ + "static/media/transaction-history-hover.7143af6a.svg";